import React from 'react';
import * as Styled from './MTextBlockSimple.styles';
import { MTextBlockSimpleProps, MTextBlockSimpleAlignment } from './MTextBlockSimple.types';

import { AEyebrow, AEyebrowVariant } from '../../atoms/AEyebrow';
import { AHeader, AHeaderSize, AHeaderTag } from '../../atoms/AHeader';
import { ABody, ABodyColor } from '../../atoms/ABody';

const COMPONENT_NAME = 'm-web-ui-kit-MTextBlockSimple';
const TEST_ID = 'web-ui-kit-MTextBlockSimple';

export const MTextBlockSimple = ({
  alignment = MTextBlockSimpleAlignment.Left,
  eyebrowText,
  eyebrowVariant = AEyebrowVariant.Primary,
  headerText,
  headerSize = AHeaderSize.TitleM,
  headerTag,
  bodyText,
  bodySize,
  bodyColor = ABodyColor.Default,
}: MTextBlockSimpleProps) => {
  return (
    <Styled.Wrapper data-component-name={COMPONENT_NAME} data-testid={TEST_ID} alignment={alignment}>
      {eyebrowText && <AEyebrow variant={eyebrowVariant}>{eyebrowText}</AEyebrow>}
      {headerText && (
        <AHeader
          size={headerSize}
          text={headerText}
          {...(headerTag ? { element: headerTag as AHeaderTag } : {})}
        ></AHeader>
      )}
      {bodyText && <ABody bodyText={bodyText} size={bodySize} color={bodyColor} />}
    </Styled.Wrapper>
  );
};

export { MTextBlockSimpleAlignment, TEST_ID as M_TEXT_BLOCK_SIMPLE_TEST_ID };
